// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_1plC6","footer":"index_footer_YtA40","checkedText":"index_checkedText_205qX","checkedNum":"index_checkedNum_28OJu"};